exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-d295be4c]::-webkit-outer-spin-button,\ninput[data-v-d295be4c]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type=number][data-v-d295be4c] {\n  -moz-appearance:textfield;\n}\n", ""]);

// exports
